// extracted by mini-css-extract-plugin
export default {"main":"e327c7bf44 ee3a4280fb","xmark":"_48d631d2c2","fl_img":"_0937a7f9c3 _571c777deb"};